import { toast } from 'react-toastify'
import {
  getAllCategories,
  getCategoryById,
  getResourcesByCategoryId,
} from '../../../api/candidate/resources'
import {
  // resourceDocument,
  resourceDocumentCountResponse,
  // resourceDocumentResponse,
  resourceDocumentResponse2,
  // resourcesCategories,
  resourcesCategoriesResponse,
  // resourcesCategoriesResponse2,
  resourcesCountRes,
} from '../../../utils/types'

export const getCategoriesData = async (
  currentPage: number
): Promise<resourcesCountRes> => {
  const response = (await getAllCategories(
    currentPage
  )) as resourcesCategoriesResponse

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}

export const getCategoriesDataById = async (
  id: string,
  currentPage: number
): Promise<resourcesCountRes> => {
  const response = (await getCategoryById(
    id,
    currentPage
  )) as resourcesCategoriesResponse

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}

export const getResourcesDataById = async (
  id: string
): Promise<resourceDocumentCountResponse> => {
  const response = (await getResourcesByCategoryId(
    id
  )) as resourceDocumentResponse2

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}
